module.exports = __webpack_public_path__ + "static/media/lv2-2c.43c2c073.mp3";